import { Injectable, OnDestroy } from '@angular/core';

import {
	SearchBarXQuery,
	ToolbarButtons,
	ToolbarEvents
} from "./toolbar-events.model";

import { BehaviorSubject, Subject } from 'rxjs';
import { SearchBarComponent } from '../../components';
import { TopbarTablesTotalComponent } from 'src/app/features/tables/components/topbar-tables-total';
import { BookingTopbarComponent } from 'src/app/features/bookings/components/booking-topbar';

export type CentralToolbarComponent = (typeof SearchBarComponent) | (typeof TopbarTablesTotalComponent) | (typeof BookingTopbarComponent);

/**
 * Service for managing toolbar events and state.
 * [toolbar documentation](https://scloby.atlassian.net/wiki/spaces/DT/pages/2408382468/Toolbar)
 */
@Injectable({
	providedIn: 'root'
})
export class ToolbarEventsService implements OnDestroy {
	//Contiene i subject di tutti i moduli (e quindi gli eventi toolbar)
	centralToolbarComponent$ = new BehaviorSubject<CentralToolbarComponent | undefined>(SearchBarComponent);
	searchBarValue$ = new BehaviorSubject<string>('');
	searchBarcode$ = new BehaviorSubject<boolean>(false);
	searchBarIcon$ = new BehaviorSubject<string>('tune');
	searchBarAction$ = new BehaviorSubject<ToolbarEvents | undefined>(undefined);
	searchBarIconFilled$ = new BehaviorSubject<string>('');
	searchBarActionFilled$ = new BehaviorSubject<ToolbarEvents | undefined>(undefined);
	searchBarXQuery: SearchBarXQuery = {
		customers: ['company_name', 'first_name', 'last_name', 'email', 'email_pec', 'mobile', 'phone', 'vat_code', 'tax_code', 'fidelity'],
		history_sales: ['sale_customer.first_name', 'sale_customer.last_name', 'sale_customer.company_name', 'seller_name', 'name', 'sale_documents.printer_name', 'sale_items.name'],
		history_e_invoices: ['sale_customer.first_name', 'sale_customer.last_name', 'sale_customer.company_name', 'customer_tax_code', 'sale_documents.sequential_number_prefix', 'sale_documents.sequential_number'],
		history_cash_movements: ['id', 'date', 'type', 'description', 'payment_method_name', 'card_circuit_name', 'amount', 'sale_id', 'account', 'created_at', 'updated_at'],
		history_products_deleted: ['sale_item_deleted_at', 'lastupdate_at', 'sale_id', 'sale_name', 'item_id', 'name', 'sku', 'category_name', 'department_name', 'vat_perc', 'price', 'cost', 'operator_name', 'room_name', 'table_name', 'covers', 'order_type', 'quantity_difference', 'revenues'],
		items: ['sku', 'id', 'code', 'name'],
		stock: ['name', 'details', 'stock_quantity', 'value', 'lastupdate_at']
	};
	showButtonsBar$ = new BehaviorSubject<boolean>(true);
	events = new Subject<ToolbarEvents>();
	buttons$ = new BehaviorSubject<ToolbarButtons>({ panelButtons: [], barButtons: [] });
	moduleTitle = new Subject<string>();

	constructor() {
		this.events.subscribe();
	}

	ngOnDestroy() {
		this.events.unsubscribe()
	}
}
